<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="headline d-flex">
                    <div>Utbetalinger: {{app.name}}</div>

                    <v-chip :color="totalPayments >= app.grant? 'error': 'success'" class="ml-2">Betalt {{totalPayments}} av {{app.grant ? app.grant : 0}}</v-chip>
                    <div class="mx-2"></div>
                    <v-btn fab x-small color="success" @click="showApplicationSummary = true;">
                        <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                </div>

                <br>
                <!-- <payment>
                </payment> -->

                <div class="grey lighten-3 pa-5" style="border: 1px solid grey; border-radius: 10px;">
                    <div class="title">Ny betaling</div>
                    <div>
                        <v-radio-group v-model="paymentAgainstReport">
                            <v-radio label="Utbetaling mot rapport" :value="true"></v-radio>
                            <v-radio label="Utbetaling uten rapport" :value="false"></v-radio>
                        </v-radio-group>
                    </div>

                    <v-slide-y-transition>
                        <div v-if="paymentAgainstReport">
                            <div>Reporter</div>

                            <v-row>
                                <v-col :sm="this.selectedReport? 6 : 12" :cols="12">
                                    <v-slide-x-reverse-transition>
                                        <v-simple-table class="text-no-wrap">
                                            <template v-slot:default>
                                                <thead>
                                                    <th>
                                                        Dato og tid
                                                    </th>
                                                    <th>
                                                        Beskrivelse
                                                    </th>
                                                    <th>
                                                        Ønsket beløp
                                                    </th>
                                                    <th>
                                                        Konto
                                                    </th>
                                                    <th>
                                                        Billag
                                                    </th>
                                                    <th>
                                                        Utbetalinger
                                                    </th>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="!app || !app.reports || app.reports.length == 0">
                                                        <td colspan="6">
                                                            <div v-if="!appLoading" class="text-center grey--text">ingen rapporter...</div>
                                                            <v-progress-linear v-if="appLoading" indeterminate></v-progress-linear>
                                                        </td>
                                                    </tr>
                                                    <tr v-for="_report in app.reports" :key="_report.id" @click="selectReport(_report)" style="cursor: pointer;">
                                                        <td width="20%">
                                                            <div class="d-flex" style="align-items: center;">
                                                                <v-checkbox :value="selectedReport === _report"></v-checkbox>
                                                                <div>
                                                                    {{moment.unix(_report.createdAt).format("YYYY-DD-MM HH:mm")}}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td :class="$vuetify.breakpoint.smAndDown? 'text-no-wrap': 'text-wrap'">{{_report.description}}</td>
                                                        <td>{{_report.amount}}</td>
                                                        <td>{{_report.account}}</td>
                                                        <td>{{_report.contents.length}}</td>
                                                        <td>
                                                            <v-chip :color="_report.payments.length == 0? 'error':'success'" small>
                                                                {{_report.payments.length}}
                                                            </v-chip>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-slide-x-reverse-transition>

                                </v-col>

                                <v-col :sm="this.selectedReport? 6 : 12" :cols="12">
                                    <v-slide-x-reverse-transition hide-on-leave>
                                        <report v-if="this.selectedReport && this.selectedReport.id > 0" :id="this.selectedReport.id">
                                        </report>
                                    </v-slide-x-reverse-transition>
                                </v-col>

                            </v-row>

                            <!-- <br> -->
                        </div>

                    </v-slide-y-transition>

                    <div class="d-flex">
                        <v-text-field v-model="paymentAccount" label="Konto" filled hide-details clearable></v-text-field>
                        <v-text-field v-model="paymentAmount" label="Utbetalingsbeløp" filled hide-details clearable class="ml-2"></v-text-field>
                    </div>

                    <v-btn :disabled="!paymentAmount || paymentAmount.trim().length == 0 || !paymentAccount || paymentAccount.trim().length == 0" color="success" class="mt-2" @click="createPayment">
                        Betale
                    </v-btn>
                </div>

                <!-- <hr class="mt-10"> -->
                <br>

                <div class="grey lighten-3 pa-5" style="border: 1px solid grey; border-radius: 10px;">
                    <v-expansion-panels flat>
                        <v-expansion-panel class="transparent">
                            <v-expansion-panel-header class="pa-0">
                                <div class="title">Tidligere utbetalinger{{app && app.payments ? ": "+app.payments.length : ": "+0}}</div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <th>Dato og tid</th>
                                            <th>Beløp</th>
                                            <th>Report</th>
                                            <th>Godkjent av</th>
                                        </thead>
                                        <tbody>
                                            <!-- <tr v-for="_payment in app.payments" :key="_payment.id" :style="{cursor: _payment && _payment.report_id && _payment.report_id > 0? 'pointer':'default'}"> -->
                                            <tr v-for="_payment in app.payments" :key="_payment.id">
                                                <td>{{moment.unix(_payment.createdAt).format("YYYY-MM-DD HH:mm")}}</td>
                                                <td>{{_payment.amount}}</td>
                                                <td>
                                                    <v-btn v-if="_payment.report_id && _payment.report_id > 0" @click.stop="rowClicked(_payment)" rounded color="success" width="100">
                                                        <div v-if="!paymentSelection[0] || paymentSelection[0].id !== _payment.id">vise</div>
                                                        <div v-else>skjul</div>
                                                    </v-btn>
                                                    <v-btn v-else rounded width="100" :disabled="true">ingen</v-btn>
                                                </td>
                                                <td>{{_payment.createdBy.firstname}} {{_payment.createdBy.lastname}} - {{_payment.createdBy.email}}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>

                                <br>

                                <v-slide-y-transition>
                                    <report v-if="paymentSelection[0] && paymentSelection[0].id > 0" :id="paymentSelection[0].report_id">

                                    </report>
                                </v-slide-y-transition>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </div>

            </v-col>
        </v-row>

        <v-dialog v-model="showApplicationSummary" max-width="750px">
            <v-card @click="showApplicationSummary = false">
                <v-card-title class="white--text" :style="{'background': colors().primary1}">
                    {{this.app.name}}
                </v-card-title>
                <v-card-text>
                    <application-summary :id="id"></application-summary>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import * as moment from "moment";
import * as axios from "axios";
export default {
    props: ["id"],
    data() {
        return {
            app: {
                name: "-"
            },
            appLoading: false,
            showApplicationSummary: false,
            paymentHeaders: [
                { text: "Dato og tid", value: "createdAt" },
                { text: "Beløp", value: "amount" },
                { text: "Report", value: "_report", sortable: false },
                { text: "Godkjent av", value: "createdBy" }
            ],
            paymentSelection: [],
            paymentAgainstReport: true,
            selectedReport: undefined,
            paymentAmount: undefined,
            paymentAccount: undefined,
            moment: moment
        };
    },
    computed: {
        totalPayments() {
            if (!this.app || !this.app.payments) {
                return 0;
            }

            let totalPayments = this.app.payments.reduce((acc, cur) => {
                return acc + cur.amount;
            }, 0);
            return totalPayments;
        }
    },
    methods: {
        async createPayment() {
            let paymentDTO = {
                account: this.paymentAccount,
                amount: this.paymentAmount
            };

            await axios.post("/payment", {
                payment: paymentDTO,
                application: this.app,
                report: this.selectedReport
            });

            await this.getApplication();
        },
        rowClicked: function(row) {
            if (!row.report_id || row.report_id == 0) return;

            if (this.paymentSelection[0] === row) {
                this.$set(this.paymentSelection, 0, undefined);
                return;
            }

            this.$set(this.paymentSelection, 0, row);
        },
        selectReport: function(report) {
            if (this.selectedReport === report) {
                this.selectedReport = undefined;
            } else {
                this.selectedReport = report;
            }
        },
        async getApplication() {
            this.appLoading = true;

            this.app = await this.$store.dispatch("getApplication", {
                applicationId: this.id,
                include: "[applicationChoices,procurements,procurementSplits,fundings,reports.[contents,createdBy,payments],payments.[createdBy],statuses,createdBy,updatedBy,ownedBy]"
            });
            this.appLoading = false;
        }
    },
    watch: {
        selectedReport: {
            handler: function(report) {
                if (!report) {
                    this.paymentAmount = undefined;
                    this.paymentAccount = undefined;
                } else {
                    this.paymentAmount = report.amount.toString();
                    this.paymentAccount = report.account.toString();
                }
            }
        },
        paymentAgainstReport: {
            handler: function(val) {
                if(!val){
                    this.paymentAccount = this.app.account;
                }
            }
        }
    },
    async mounted() {
        this.moment.locale("nb");
        this.getApplication();
    }
};
</script>

<style lang="scss">
v-data-table {
    background: "transparent";
}

v-simple-table {
    background: "transparent";
}

v-expansion-panel-content__wrap {
    padding: 0px;
}
</style>